import React from "react";
import { ValidationErrors } from "src/errors";
import { AuthFormData, AuthFormDataKey } from "src/types";
import { TextInputBox, FormLvlErrorMessage } from "src/components";
import { Link } from "react-router-dom";

interface AuthSignUpProps {
  formData: AuthFormData;
  validationErrors?: ValidationErrors<AuthFormDataKey>;
  formLvlErrorMessage: string;
  handleInputChange: (field: AuthFormDataKey, value: string) => void;
}

const AuthSignUp: React.FC<AuthSignUpProps> = ({
  formData,
  validationErrors,
  formLvlErrorMessage,
  handleInputChange
}) => {
  return (
    <div className="space-y-8">
      <div className="lg:hidden text-center">
        <div className="inline-flex items-center">
          <img src="/logo.png" alt="Healf Logo" className="w-20" />
        </div>
      </div>

      <div className="text-center">
        <h2 className="text-3xl font-bold text-secondary-900 mb-2">Create Account</h2>
        <p className="text-secondary-600">Sign up for a new account</p>
      </div>

      <div className="space-y-6">
        <div>
          <TextInputBox
            id="email"
            label="Email Address"
            placeholder="Enter your email"
            value={formData.email}
            onChange={(value: string) => handleInputChange("email", value.toLowerCase())}
            type="email"
            required
            error={validationErrors?.getErrorMessageByFormDataKey("email")}
          />
        </div>

        <div>
          <TextInputBox
            id="password"
            label="Password"
            placeholder="Create a password"
            value={formData.newPassword}
            onChange={(value: string) => handleInputChange("newPassword", value)}
            type="password"
            required
            error={validationErrors?.getErrorMessageByFormDataKey("newPassword")}
          />
        </div>

        <div>
          <TextInputBox
            id="confirm-password"
            label="Confirm Password"
            placeholder="Confirm your password"
            value={formData.confirmPassword}
            onChange={(value: string) => handleInputChange("confirmPassword", value)}
            type="password"
            required
            error={validationErrors?.getErrorMessageByFormDataKey("confirmPassword")}
          />
        </div>

        <FormLvlErrorMessage message={formLvlErrorMessage} centred={false} />

        <div className="space-y-4">
          <button
            className="w-full bg-primary-600 hover:bg-primary-700 disabled:bg-primary-300 disabled:cursor-not-allowed text-white font-medium py-3 px-4 rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
            disabled={!formData.email || !formData.newPassword || !formData.confirmPassword}
            type="submit"
          >
            Create Account
          </button>
          <div className="text-center mt-6">
            <p className="text-secondary-600">
              Already have an account?{" "}
              <Link
                to="/"
                className="text-primary-600 hover:text-primary-700 font-medium underline focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
              >
                Sign in
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export { AuthSignUp };
